import { render, staticRenderFns } from "./QuestionBackButton.vue?vue&type=template&id=cc1130e8&scoped=true&"
import script from "./QuestionBackButton.vue?vue&type=script&lang=js&"
export * from "./QuestionBackButton.vue?vue&type=script&lang=js&"
import style0 from "./question-back-button.scss?vue&type=style&index=0&id=cc1130e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1130e8",
  null
  
)

export default component.exports